import { ComponentProps } from 'react'

import { astraTwMerge } from '~/astra'

const buttonBaseStyles = 'rounded-2xl cursor-pointer disabled:opacity-50 disabled:pointer-events-none h-16 flex justify-center items-center '

type Props = ComponentProps<'a'>

export const LinkButton = ({ children, className, ...props }: Props) => (
    <a
        className={astraTwMerge(
            buttonBaseStyles,
            'bg-brand-strong-rest px-5 text-lg text-white hover:bg-brand-strong-hover active:bg-brand-strong-active',
            className,
            'transition-none'
        )}
        {...props}
    >
        {children}
    </a>
)
